import React, { PureComponent } from 'react';
import { Search } from 'semantic-ui-react';
import style from './styles/style.module.css';

export default class DLSearch extends PureComponent {
    onKeyDown = ( e ) => {
        this.props.onKeyDown( e );
        if( e.keyCode == 13 && this.props.onSubmit ) {
            e.preventDefault();
            this.props.onSubmit( e );
        }
    }
    render() {
        var value;
        const { label, results } = this.props;
        const inlineStyle = { ...this.props.style };

        return (
            <div className={ `semantic-wrapper ${ style.semanticAutoComplete } ${ this.props.className }` }
            data-full-width={ this.props.fullWidth }
            style={ inlineStyle }>
                { label &&
                    <label>{ label }</label>
                }
                <Search className={ `semantic-search ${ style.semanticSearch }` }
                value={ value }
                results={ results }
                type={ this.props.type }
                autoFocus={ this.props.autoFocus }
                open={ this.props.open }
                onSearchChange={ this.props.onChange }
                onFocus={ this.props.onFocus }
                onBlur={ this.props.onBlur }
                onResultSelect={ this.props.onResultSelect }
                onKeyDown={ this.onKeyDown }
                required={ this.props.required }
                placeholder={ this.props.placeholder }
                icon={ this.props.icon }
                maxLength={ this.props.maxLength }
                showNoResults={ this.props.showNoResults }
                category={ this.props.category }
                resultRenderer={ this.props.resultRenderer }
                minCharacters={ this.props.minCharacters } />
                { this.props.hintMessage &&
                    <p className='hint-message'>{ this.props.hintMessage }</p>
                }
                <p className='error-message'>{ this.props.error }</p>
            </div>
        );
    }
}

DLSearch.defaultProps = {
    className: '',
    style: {},
    results: [],
    onChange: ()=>{},
    onFocus: ()=>{},
    onBlur: ()=>{},
    onKeyDown: ()=>{},
    onResultSelect: ()=>{},
    icon: null,
};
